module.exports = [{"lineNo":"0","lineDesc":"","lineColor":""},{"lineNo":"1","lineDesc":"山線","lineColor":"green"},{"lineNo":"2","lineDesc":"海線","lineColor":"blue"}]


//////////////////
// WEBPACK FOOTER
// ./static/triplines.json
// module id = 1PUk
// module chunks = 1